export const NAMESPACE = 'PATIENTS/WEEKLY_REPORT';